import React from "react";
import { useTranslation } from "react-i18next";
import { Alert, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

/**
 * Error state for a Tasks-hub section whose data fetch failed. Rendered in
 * place of the section's table/empty body so a failed fetch is never mistaken
 * for an empty section — the bug this fixes is that a 4xx/5xx on a section's
 * feed used to fall through to the "Nothing to ..." empty state, so the
 * navigator saw "no work" instead of "this failed to load". Offers a Retry
 * that re-invokes the section's fetch.
 */
// eslint-disable-next-line react/prop-types
const SectionError = ({ onRetry, testId }) => {
  const { t } = useTranslation();
  return (
    <div style={{ padding: 16 }} data-testid={testId}>
      <Alert
        type="error"
        showIcon
        message={t("agentic_tasks.section_error_title")}
        description={t("agentic_tasks.section_error_desc")}
        action={
          <Button
            size="small"
            icon={<ReloadOutlined />}
            onClick={onRetry}
            data-testid={testId ? `${testId}-retry` : undefined}
          >
            {t("agentic_tasks.section_error_retry")}
          </Button>
        }
      />
    </div>
  );
};

export { SectionError };
